import React, { useEffect, useState } from 'react';
import './CardVIew.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useAuth } from '../../AuthContext';
import { API_URL } from '../../Config';
import { Link } from 'react-router-dom';

const CardView = () => {
  const [isFormOpenForAddTask, setIsFormOpenForAddTask] = useState(false);
  const [isFormOpenForCard, setIsFormOpenForCard] = useState(false)
  const { user } = useAuth();
  const username = user.user;
  const [tasks, setTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [searchInput, setSearchInput] = useState('');
  const [selectedSort, setSelectedSort] = useState('');
  const [assigneeDetails, setAssigneeDetails] = useState(null);

  useEffect(() => {
    let endpoint = API_URL + `/tasks/?assignee=${username.username}`;

    if (username.role === 'Admin' || username.role === 'HR') {
      endpoint = API_URL + '/tasks/all';
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  }, [username.username, username.role]);

  const fetchTasks = (filterValue, selectedSort) => {
    selectedSort = selectedSort || '';
    let endpoint;

    if (!filterValue && !selectedSort) {
      if (username.role === 'Admin' || username.role === 'HR') {
        endpoint = API_URL + '/tasks/all';
      } else {
        endpoint = API_URL + `/tasks/?assignee=${username.username}`;
      }
    } else {
      if ((filterValue || selectedSort) && (username.role === 'Admin' || username.role === 'HR')) {
        endpoint = `${API_URL}/tasks/?assignee=&filter=${filterValue}&sort=${selectedSort}`;
      } else if (filterValue || selectedSort) {
        endpoint = `${API_URL}/tasks/?assignee=${username.username}&filter=${filterValue}&sort=${selectedSort}`;
      } else if (username.role === 'Admin' || username.role === 'HR') {
        endpoint = `${API_URL}/tasks/all`;
      } else {
        endpoint = `${API_URL}/tasks/?assignee=${username.username}&sort=${selectedSort}`;
      }
    }
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => setTasks(data))
      .catch((error) => console.error(error));
  };

  const openForm1 = () => {
    setIsFormOpenForAddTask(true);
  };

  const closeForm1 = () => {
    setIsFormOpenForAddTask(false);
  };

  const openForm2 = async (task) => {
    setSelectedTask(task);
    setIsFormOpenForCard(true);
    try {
      const response = await fetch(`${API_URL}/users/${task.assignee}`);
      if (!response.ok) {
        throw new Error('Failed to fetch user details');
      }

      const data = await response.json();
      setAssigneeDetails(data);
    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const closeForm2 = () => {
    setIsFormOpenForCard(false);
  };

  const clearFilters = () => {
    setSearchInput('');
    setSelectedSort('');
    fetchTasks('', '');
  };

  return (
    <div>
      <SideMenuBar></SideMenuBar>

      <div class="content">
        <NewHeader></NewHeader>

        <div className='row2'>
          <h3 className='tasks'>Tasks</h3>
          <Link to='/ListView' className='a_list_CardView' ><p className='list_CardView'>List</p></Link>
          <Link to='/CardVIew' className='a_card_CardView'><p className='card_CardView'>Card</p></Link>
        </div>

        <div className='row3'>
          <div className='searchBox'>
            <div class="column1_searchBox">
              <img className='search' src="../assets/search.png" alt="search" height={"18px"}></img>
            </div>

            <div class="column2_searchBox">
              <input className='search_input1' placeholder='Search' value={searchInput}
                onChange={(e) => {
                  const text = e.target.value;
                  setSearchInput(text);
                  fetchTasks(text, selectedSort);
                }}></input>
            </div>
          </div>
          <button className='add_task_btn' onClick={openForm1}> + Add task {/*<img className='plus' src="../assets/plus.png" alt="plus" height={"8px"}></img>*/} </button>

          <select className='sort_by' name='' value={selectedSort}
            onChange={(e) => {
              const value = e.target.value;
              setSelectedSort(value);
              fetchTasks(searchInput, value);
            }}>
            <option value="" selected disabled hidden>Sort by</option>
            <option className='options'>Pending</option>
            <option className='options'>In-Process</option>
            <option className='options'>Complete</option>
          </select>
          <button className='clear_filter_btn' onClick={clearFilters}>Clear Filters</button>
        </div>
        {isFormOpenForAddTask && (
          <>
            <div className="overlay_CardView" onClick={closeForm1}></div>
            <div className="popup-form_CardView">
              <span className="close_CardView" onClick={closeForm1}>&times;</span>
              <p><b>Add Task</b></p>
              {/* Your form content goes here */}
              <form>
                {/* Form fields go here */}
                <input className='enter_assignee_name_input_CardView' placeholder='Enter Name of the Assignee'></input>
                <p>Task</p>
                <textarea className='task_details_input_CardView' placeholder='Enter Task Details Here...'></textarea>

                <div class="popup_row">
                  <div class="popup_column1">

                    <p>Priority</p>
                    <select className='popup_form_select' name=''>
                      <option value="none" selected disabled hidden>Select</option>
                      <option className='options'>High</option>
                      <option className='options'>Medium</option>
                      <option className='options'>Low</option>
                    </select>

                    <p>Role</p>
                    <select className='popup_form_select' name=''>
                      <option value="none" selected disabled hidden>Select</option>
                      <option className='options'>Super Admin</option>
                      <option className='options'>Hr Admin</option>
                      <option className='options'>Employee</option>
                    </select>

                    <p>Status</p>
                    <select className='popup_form_select' name=''>
                      <option value="none" selected disabled hidden>Select</option>
                      <option className='options'>Pending</option>
                      <option className='options'>In-Process</option>
                      <option className='options'>Complete</option>
                    </select>
                  </div>

                  <div class="popup_column2">

                    <p>Created Date</p>
                    <input type="date" id="date" name="date" className='popup_form_created_date_CardView' />

                    <p>Deadline</p>
                    <input type="date" id="date" name="date" className='popup_form_deadline_CardView' />

                    <p>Given By </p>
                    <input className='popup_form_given_by_CardView' placeholder='Enter'></input><br />

                    <button type="submit" value="Submit" className='popup_form_addTask_CardView' >Add Task</button>
                    <button type="submit" value="close" onClick={closeForm1} className='popup_form_cancel_CardView'>Cancel</button>
                  </div>
                </div>



              </form>
            </div>
          </>
        )}

        <div className='row4'>
          <h5>All Tasks</h5>
        </div>


        <div class="row_CardView" >
          {tasks.length > 0 ? (
            tasks.map((task, index) => (
              <div key={index} className="column1_CardView" onClick={() => openForm2(task)}>
                <p className='assignee'>{task.assignee}</p>

                <div className="inner_row_CardView">
                  <div className="inner_column1_CardView">
                    <p>Task</p>
                    <p>Priority</p>
                    <p>Role</p>
                    <p>Deadline</p>
                    <p className='updated_date'>{`$updated '' days ago`}</p>
                  </div>

                  <div className="inner_column2_CardView">
                    <p className='clean_up'><b>{task.category}</b></p>
                    <button className={task.priority.toLowerCase()} disabled>{task.priority}</button><br />
                    <button className={task.role.toLowerCase()} disabled>{task.role}</button>
                    <p className='date'><b>{task.deadline}</b></p>
                    <button className={task.status.toLowerCase()} disabled>{task.status}</button>
                  </div>
                </div>
              </div>

            ))
          ) : (
            <p>No tasks available</p>
          )}

          {isFormOpenForCard && selectedTask && (
            <>
              <div className="overlay2_CardView" onClick={closeForm2}></div>
              <div className="popup-form2_CardView">
                <span className="close2_CardView" onClick={closeForm2}>&times;</span>
                <h3 className='name_cardView'>{selectedTask.assignee}</h3><hr className='hr_of_CardView' />
                {/* Your form content goes here */}
                <form>
                  {/* Form fields go here */}
                  <p style={{ fontSize: '1vw' }}><b>Task Information</b></p>

                  <div class="row1_popup_form_forCard">
                    <div class="column1_popup_form_forCard">
                      <p>Task</p>
                      <p>Priority</p>
                      <p>Status</p>
                      <p>Role</p>
                      <p>Deadline</p>
                      <p>Site Location</p>
                      <p>Created Date</p>
                      <p>Given By</p>
                    </div>

                    <div class="column2_popup_form_forCard">
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                    </div>

                    <div class="column3_popup_form_forCard">
                      <p><b>{selectedTask.category || "not avalible"}</b></p>
                      <p><b>{selectedTask.priority || "not avalible"}</b></p>
                      <p><b>{selectedTask.status || "not avalible"}</b></p>
                      <p><b>{selectedTask.role || "not avalible"}</b></p>
                      <p><b>{selectedTask.deadline || "not avalible"}</b></p>
                      <p><a href='/' style={{ color: '#173452' }}><b>View more</b></a></p>
                      <p><b>{selectedTask.createdAt || "not avalible"}</b></p>
                      <p><b>{selectedTask.assignedFrom || "not avalible"}</b></p>
                    </div>
                  </div> <hr className='hr_of_CardView' />

                  <p style={{ fontSize: '1vw' }}><b>Personal Information</b></p>
                  <div class="row2_popup_form_forCard">
                    <div class="column1_popup_form_forCard">
                      <p>Name</p>
                      <p>Work</p>
                      <p>Phone no.</p>
                      <p>Email ID</p>
                      <p>Current Address</p>

                    </div>

                    <div class="column2_popup_form_forCard">
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>
                      <p><b>:</b></p>

                    </div>

                    <div class="column3_popup_form_forCard">
                      {assigneeDetails ? (
                        <>
                          <p><b>{assigneeDetails.username || "not avalible"}</b></p>
                          <p><b>{assigneeDetails.work_type || "not avalible"}</b></p>
                          <p><b>{assigneeDetails.mobile || "not avalible"}</b></p>
                          <p><b>{assigneeDetails.email || "not avalible"}</b></p>
                          <p><b>{assigneeDetails.address || "not avalible"}</b></p>
                        </>
                      ) : (
                        <p>Loading assignee details...</p>
                      )}
                    </div>
                  </div>

                  <div class="row_time">
                    <div class="column1_start_time">
                      <p className='start_time'>Start Time <b>00:00:00</b></p>
                    </div>
                    <div class="column2_end_time">
                      <p className='end_time'>End Time <b>00:00:00</b></p>
                    </div>
                  </div>
                  <div class="div_total_time">
                    <p className='total_time'>Total Time <b>00:00:00</b></p>
                  </div>


                </form>
              </div>
            </>
          )}
        
        </div>


        <br /><br /><br /><br /><br />

      </div>

    </div>
  )
}

export default CardView;